import SectionDisplayCard from "../components/SectionDisplayCard/SectionDisplayCard";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import NavbarDashboard from "../components/navbarDashboard/NavbarDashboard";
import ButtonEditPage from "../components/ButtonEditPage/ButtonEditPage";
import React, { useState } from "react";
import ProgressBar from "../components/ProgressBar/ProgressBar";
import "../components/SectionDisplayCard/SectionDisplayCard.css";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

function SectionDisplayPage() {
  const { id, currentYear, currentQuarter } = useParams();
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const cardData = [
    {
      title: "Seminars and Workshops attended",
      content:
        "",
    },
    {
      title: "Conference /Seminars /Workshops Organized",
      content:
        "",
    },
    {
      title: "Faculty participation in GATE/NET",
      content:
        "",
    },
    {
      title: "Books/Chapters published by faculty members",
      content:
        "",
    },
    {
      title: "Patents obtained",
      content:
        "",
    },
    {
      title: "List of equipments added during the period (costing more than Rs 50,000)",
      content:
        "",
    },
    {
      title: "Financial assistance received (except sponsored project)",
      content:
        "",
    },
    {
      title: "R & D proposals submitted",
      content: "",
    },
    {
      title: "New Laboratories / Centers Added",
      content: "",
    },
    {
      title: "List of Papers Published (Count Only)",
      content: "",
    }
  ];
  const navigate = useNavigate();
  const handleClick = (title) => {
    const encodedTitle = encodeURIComponent(title);
    navigate(
      `/representativeEdit/${id}/${currentYear}/${currentQuarter}/${encodedTitle}`
    );
  };

  return (
    <div>
      <NavbarDashboard />
      <ButtonEditPage
        title="Progress"
        style={{ marginLeft: "5%", marginTop: "7%" }}
      />
      <div className="grid-container" style={{ marginTop: "1%" }}>
        {cardData.map((card, index) => (
          <SectionDisplayCard
            key={index}
            title={card.title}
            content={card.content}
            onClickCard={() => handleClick(card.title)}
          />
        ))}
      </div>
      {/* <ButtonEditPage title="Submit" style={{ marginLeft: "45%" }} /> */}
      <React.Fragment>
        <Button
          variant="outlined"
          onClick={handleClickOpen}
          sx={{
            color: "#FFFFFF",
            backgroundColor: "#185873",
            marginLeft: "45%",
            "&:hover": {
              backgroundColor: "#185887",
            },
          }}
        >
          SUBMIT
        </Button>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Are you sure you want to submit the report? "}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              If you submit it, you cannot edit it, as the report will now be
              accessible to the HOD of your department.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>
              <ButtonEditPage title="Cancel" />
            </Button>
            <Button onClick={handleClose} autoFocus>
              <ButtonEditPage title="Submit" />
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    </div>
  );
}
export default SectionDisplayPage;
